(() => {
  'use strict';
  if(customElements.get('mb-product-info'))return;
  class MBProductInfo extends HTMLElement {
    connectedCallback(){
      this.sectionId=this.dataset.sectionId;
      this.url=this.dataset.url||location.pathname;
      this.form=this.querySelector('form[action*="/cart/add"]');
      this.idInput=this.form?.querySelector('input[name="id"]');
      this.variantData=this.readVariants();
      this.pickers=[...this.querySelectorAll('[data-option-position]')];
      this.pickers.forEach(p=>p.addEventListener('change',()=>this.onVariantChange()));
      this.onVariantChange(false);
    }
    readVariants(){const el=this.querySelector('[data-variants-json]')||document.querySelector('[data-variants-json]');try{return JSON.parse(el?.textContent||'[]')}catch{return[]}}
    options(){return this.pickers.map(p=>{const checked=p.querySelector('input:checked');const select=p.querySelector('select');return checked?.value??select?.value??'';});}
    variant(){
      // Single-variant products do not render an option picker. In that case,
      // resolve the variant from the hidden Shopify variant-id input instead
      // of trying to match an empty option array.
      if(!this.pickers.length){
        const currentId=Number(this.idInput?.value||0);
        return this.variantData.find(v=>Number(v.id)===currentId)
          || this.variantData.find(v=>v.available)
          || this.variantData[0];
      }
      const o=this.options();
      return this.variantData.find(v=>v.options.every((x,i)=>x===o[i]));
    }
    onVariantChange(push=true){
      const v=this.variant(); if(!v){this.setUnavailable();return;}
      if(this.idInput){this.idInput.value=v.id;this.idInput.disabled=!v.available;}
      this.updateState(v); this.updateMedia(v);
      if(push && history.replaceState){const u=new URL(this.url,location.origin);u.searchParams.set('variant',v.id);history.replaceState({},'',u);}
      document.dispatchEvent(new CustomEvent('variant:change',{detail:{variant:v,productInfo:this}}));
    }
    publicSku(raw){
      const s=String(raw||'').trim();
      if(!s||/^BOOK-/i.test(s))return '';
      return s;
    }
    identifier(v,el){
      const fallbackIsbn=String(el.dataset.fallbackIsbn||'').trim();
      const fallbackSku=this.publicSku(el.dataset.fallbackSku||'');
      const barcode=String(v.barcode||'').trim();
      const value=barcode||fallbackIsbn||fallbackSku;
      let label='';
      if(value){if(/^\d{13}$/.test(value))label='ISBN-13';else if(/^\d{10}$/.test(value))label='ISBN-10';else if(barcode)label='Barcode';else label='SKU';}
      return {value,label};
    }
    updateIdentifier(el,v){
      const {value,label}=this.identifier(v,el);el.textContent=value;
      const row=el.closest('[data-public-identifier-row]');
      const labelEl=row?.querySelector('[data-product-identifier-label]');
      if(labelEl)labelEl.textContent=label;
      if(row)row.hidden=!value;
    }
    updateState(v){
      this.querySelectorAll('[data-variant-price]').forEach(el=>el.textContent=this.money(v.price));
      this.querySelectorAll('[data-compare-price]').forEach(el=>{el.textContent=v.compare_at_price?this.money(v.compare_at_price):'';el.hidden=!v.compare_at_price||v.compare_at_price<=v.price;});
      this.querySelectorAll('[data-product-identifier]').forEach(el=>this.updateIdentifier(el,v));
      document.querySelectorAll('[data-product-identifier-global]').forEach(el=>this.updateIdentifier(el,v));
      this.querySelectorAll('[data-selected-option]').forEach(el=>{const pos=Number(el.dataset.selectedOption||1)-1;el.textContent=v.options[pos]||'';});
      const submit=this.querySelector('[type="submit"][name="add"]'); if(submit){submit.disabled=!v.available;const t=submit.querySelector('[data-add-text]');if(t)t.textContent=v.available?(t.dataset.available||'Add to cart'):(t.dataset.soldout||'Sold out');}
      const inventory=this.querySelector('[data-inventory-status]');
      if(inventory){
        inventory.dataset.available=String(v.available);
        const av=inventory.querySelector('[data-inventory-text]');
        const stock=Number(v.inventory_quantity||0);
        const tracked=Boolean(v.inventory_management);
        if(av){
          av.textContent=!v.available
            ? (av.dataset.soldOut||'Sold out')
            : tracked&&stock>0
              ? (stock<=5?'Only '+stock+' left':(av.dataset.inStock||'In stock'))
              : (av.dataset.availableToOrder||'Available to order');
        }
      }
      const shipping=this.querySelector('[data-shipping-clarity]');
      if(shipping&&typeof v.requires_shipping==='boolean')shipping.hidden=!v.requires_shipping;
    }
    updateMedia(v){if(!v.featured_media)return;const gallery=document.querySelector('mb-media-gallery');gallery?.setActiveMedia?.(String(v.featured_media.id));}
    setUnavailable(){const s=this.querySelector('[type="submit"][name="add"]');if(s)s.disabled=true;}
    money(cents){return window.MB?.money?window.MB.money(cents):`${(Number(cents||0)/100).toFixed(2)}`;}
  }
  customElements.define('mb-product-info',MBProductInfo);
})();
